import React, { forwardRef, LegacyRef } from 'react';
import { Box, Divider } from '@material-ui/core';
import {
  OverflowMenuVertical,
  SendFilled,
  Edit,
  TrashCan
} from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet, theme } from '@components/Provider';
import UserAvatar from '@components/Chat/ChatMenu/Viewer/components/UserAvatar';

interface FakeChatProps {
  isMenuOpen?: boolean;
  myName: string;
}

const FakeChat = forwardRef(
  ({ isMenuOpen = false, myName }: FakeChatProps, ref) => {
    return (
      <div
        style={{
          position: 'absolute',
          top: '30%',
          left: '45%',
          width: 375,
          height: 485,
          backgroundColor: 'white',
          borderRadius: 16,
          boxShadow: theme.shadows[1]
        }}
        ref={ref as LegacyRef<HTMLDivElement> | undefined}
      >
        <Box
          height={56}
          borderBottom={`1px ${colorSet.gray300} solid`}
          padding={2}
          marginBottom={2}
        >
          <CustomizedTypography variant="body1" fontWeight="700">
            주석
          </CustomizedTypography>
        </Box>
        <Box>
          <Comment
            username={myName}
            comment={
              '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.'
            }
            time={'1시간 전'}
          />
          <Comment
            reply
            username={myName}
            comment={'혹시 이부분 수정 가능할까요?'}
            time={'46분 전'}
          />
          <Comment
            reply
            username={'정문가'}
            comment={'네 그럼요~ 작업 후 전달 주세요!'}
            time={'4분 전'}
          />
          <Comment
            reply
            username={'정문가'}
            comment={'답글로 남겨주셔도 무방합니다.'}
            time={'방금 전'}
          />
        </Box>
        <Box display={'flex'} alignItems={'center'} paddingLeft={2}>
          <UserAvatar userName={myName} />
          <Box
            marginLeft={'12px'}
            borderRadius={16}
            height={44}
            width={300}
            border={`1px solid ${colorSet.gray400}`}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={`12px 16px`}
          >
            <CustomizedTypography variant="body2" color={'textSecondary'}>
              답글을 입력하세요.
            </CustomizedTypography>
            <SendFilled size={20} color={colorSet.gray300} />
          </Box>
        </Box>
        {isMenuOpen && (
          <Box
            position={'absolute'}
            top={110}
            right={22}
            display={'flex'}
            flexDirection={'column'}
            gridGap={8}
            width={242}
            height={141}
            borderRadius={8}
            padding={`8px 0 8px 0`}
            bgcolor={colorSet.gray000}
            boxShadow={theme.shadows[1]}
          >
            <Box
              display={'flex'}
              alignItems={'center'}
              width={'100%'}
              paddingLeft={'16px'}
              height={54}
              gridGap={12}
            >
              <Edit color={colorSet.gray2000} size={24} />
              <CustomizedTypography>수정하기</CustomizedTypography>
            </Box>

            <Divider color={colorSet.gray200} />

            <Box
              display={'flex'}
              alignItems={'center'}
              width={'100%'}
              paddingLeft={'16px'}
              height={54}
              gridGap={12}
            >
              <TrashCan color={colorSet.gray2000} size={24} />
              <CustomizedTypography>삭제하기</CustomizedTypography>
            </Box>
          </Box>
        )}
      </div>
    );
  }
);

export default FakeChat;

const Comment = ({
  username,
  comment,
  time,
  reply
}: {
  username: string;
  comment: string;
  time: string;
  reply?: boolean;
}) => {
  return (
    <Box
      display={'flex'}
      marginBottom={'20px'}
      marginLeft={reply ? '32px' : 0}
      padding={`0 16px 0 16px`}
    >
      <UserAvatar userName={username} />
      <Box marginLeft={'12px'}>
        <Box
          display={'flex'}
          alignItems={'center'}
          height={32}
          marginBottom={'6px'}
        >
          <Box marginRight={'8px'}>
            <CustomizedTypography variant="body1" fontWeight="500">
              {username}
            </CustomizedTypography>
          </Box>
          <Box>
            <CustomizedTypography variant="subtitle2" color={'textSecondary'}>
              {time}
            </CustomizedTypography>
          </Box>

          <Box position={'absolute'} right={16}>
            <OverflowMenuVertical color={colorSet.gray600} />
          </Box>
        </Box>
        <Box>
          <CustomizedTypography>{comment}</CustomizedTypography>
        </Box>
      </Box>
    </Box>
  );
};
